export default "__VITE_ASSET__q9pR0SCy__"